import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const PersonIconRound = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("rect", {
    width: "20",
    height: "20",
    rx: "10",
    fill: color
  }), __jsx("g", {
    clipPath: "url(#clip0_16771_4682)"
  }, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 15.5C5.41667 15.5 4.5 15.5 4.5 14.5833C4.5 13.6667 5.41667 10.9167 10 10.9167C14.5833 10.9167 15.5 13.6667 15.5 14.5833C15.5 15.5 14.5833 15.5 14.5833 15.5H5.41667ZM10 10C10.7293 10 11.4288 9.71027 11.9445 9.19454C12.4603 8.67882 12.75 7.97935 12.75 7.25C12.75 6.52065 12.4603 5.82118 11.9445 5.30546C11.4288 4.78973 10.7293 4.5 10 4.5C9.27065 4.5 8.57118 4.78973 8.05546 5.30546C7.53973 5.82118 7.25 6.52065 7.25 7.25C7.25 7.97935 7.53973 8.67882 8.05546 9.19454C8.57118 9.71027 9.27065 10 10 10Z",
    fill: "white"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_16771_4682"
  }, __jsx("rect", {
    width: "12",
    height: "12",
    fill: "white",
    transform: "translate(4 4)"
  }))));
};
export default PersonIconRound;